import { render, staticRenderFns } from "./CorreoRespuesta.vue?vue&type=template&id=cefa4a86&"
import script from "./CorreoRespuesta.vue?vue&type=script&lang=js&"
export * from "./CorreoRespuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports